import { ColumnProps } from 'antd/lib/table';

export type ColumnFilters = Partial<Record<string, string[]>>;

// A record passes a column when it matches any of that column's filter values, and must pass every filtered column
export function applyColumnFilters<T>(records: T[], columns: ColumnProps<T>[], columnFilters: ColumnFilters): T[] {
  const activeFilters = columns.flatMap((column) => {
    const values = columnFilters[String(column.key ?? column.dataIndex)];
    const onFilter = column.onFilter;
    return onFilter && values?.length ? [{ onFilter, values }] : [];
  });

  return records.filter((record) =>
    activeFilters.every(({ onFilter, values }) => values.some((value) => onFilter(value, record))),
  );
}
